(() => {
  const content = document.querySelector('.nailarts-guide-article .articles__content');
  if (!content || content.dataset.guideOrganized) return;

  const nodes = Array.from(content.children);
  let section = null;
  let cardGrid = null;

  nodes.forEach((node, index) => {
    if (node.tagName === 'H2') {
      section = document.createElement('section');
      section.className = 'nailarts-guide-section';
      if (node.textContent.trim().toLowerCase().includes('häufige fragen')) {
        section.classList.add('nailarts-guide-section--faq');
      }
      content.appendChild(section);
      section.appendChild(node);
      cardGrid = null;
      return;
    }

    if (!section) return;

    if (node.tagName === 'H3' && nodes[index + 1]?.tagName === 'P') {
      if (!cardGrid) {
        cardGrid = document.createElement('div');
        cardGrid.className = 'nailarts-guide-card-grid';
        if (section.classList.contains('nailarts-guide-section--faq')) {
          cardGrid.classList.add('nailarts-guide-card-grid--faq');
        }
        section.appendChild(cardGrid);
      }
      const card = document.createElement('div');
      card.className = 'nailarts-guide-card';
      if (section.classList.contains('nailarts-guide-section--faq')) {
        card.classList.add('nailarts-guide-card--faq');
      }
      card.appendChild(node);
      card.appendChild(nodes[index + 1]);
      cardGrid.appendChild(card);
      return;
    }

    if (node.parentElement !== content) return;

    const firstStrong = node.tagName === 'P' ? node.querySelector('strong:first-child') : null;
    if (firstStrong && node.textContent.trim().startsWith(firstStrong.textContent.trim())) {
      node.classList.add('nailarts-guide-note');
    }
    section.appendChild(node);
  });

  content.dataset.guideOrganized = 'true';
})();

